import { Wallet } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#059669";
const SEZIONI = [
  { id: "intro", titolo: "Cos'è il Foglio Cassa" },
  { id: "movimenti", titolo: "Registrare i movimenti" },
  { id: "totali", titolo: "Totali: Saldo e Rimessa" },
  { id: "direzione", titolo: "Funzioni Direzione" },
  { id: "report", titolo: "Report PDF di cassa" },
  { id: "faq", titolo: "FAQ" },
];

export default function ManualeFoglioCassa() {
  return (
    <ManualeLayout titolo="Foglio Cassa" sottotitolo="Registrazione incassi giornalieri — modello Assieasy" icona={Wallet} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="Cos'è il Foglio Cassa" accent={A}>
        <P>Il Foglio Cassa digitale sostituisce il FC cartaceo/Assieasy: ogni produttore registra gli incassi della giornata. Ogni collaboratore vede <b>solo il proprio</b> foglio; la <b>Direzione</b> vede e controlla quelli di tutti.</P>
        <P>In alto scegli la <b>Data FC</b> (default: oggi); la Direzione può anche selezionare il <b>produttore</b>.</P>
      </Scheda>

      <Scheda id="movimenti" n="2" titolo="Registrare i movimenti" accent={A}>
        <Steps items={[
          "Clicca 'Nuovo movimento'.",
          "Compila Compagnia, Ramo, N. polizza, Contraente, Sottotipo carico (es. QT – Quietanza).",
          "Scegli la Modalità di pagamento: Contante, POS, Assegno o Bonifico (l'Anticipo non è previsto).",
          "Inserisci Premio incassato e, se presenti, Provvigioni attive e Partite varie. Salva.",
        ]} />
        <Callout tipo="info">Contanti e assegni si consegnano fisicamente alla Direzione, per il POS si consegnano le ricevute; i Bonifici sono gestiti direttamente dalla Direzione.</Callout>
        <Callout tipo="ok">Alcuni movimenti possono comparire automaticamente: quando la Direzione <b>incassa un titolo</b> dalla Contabilità di Agenzia, l'incasso viene registrato nel Foglio Cassa del produttore indicato (catena unica) e confluisce anche in Prima Nota.</Callout>
      </Scheda>

      <Scheda id="totali" n="3" titolo="Totali: Saldo e Rimessa" accent={A}>
        <Bullets items={[
          "Totale Premi: somma dei premi lordi incassati.",
          "Saldo: corrisponde al totale dei premi lordi incassati (le provvigioni sono erogate a parte con l'Estratto Conto Provvigionale).",
          "Rimessa da consegnare: incassi in Contante + POS + Assegno (i Bonifici sono esclusi perché gestiti dalla Direzione).",
          "Il riepilogo mostra anche il dettaglio per singola modalità di pagamento.",
        ]} />
      </Scheda>

      <Scheda id="direzione" n="4" titolo="Funzioni Direzione" accent={A}>
        <P>La Direzione dispone del <b>Cruscotto</b> con premi, rimessa e stato di tutti i produttori del giorno.</P>
        <Steps items={[
          "Verifica la corrispondenza tra incassi registrati e quanto consegnato (contanti, ricevute POS, assegni).",
          "Clicca 'Chiudi cassa' per chiudere ufficialmente: da quel momento i movimenti sono bloccati (usa 'Riapri' se serve correggere).",
          "Per Gianfranco, registra l'OK provvigionale con l'apposito pulsante.",
        ]} />
      </Scheda>

      <Scheda id="report" n="5" titolo="Report PDF di cassa" accent={A}>
        <P>Il pulsante <b>Report PDF</b> genera un documento con riepilogo, dettaglio incassi per modalità, elenco movimenti e <b>righe per la firma</b> di consegna: utile come pezza d'appoggio firmabile per la consegna fisica di contanti e assegni.</P>
      </Scheda>

      <Scheda id="faq" n="6" titolo="FAQ" accent={A}>
        <FAQ items={[
          { q: "Perché non trovo la modalità 'Anticipo'?", a: "Nel Foglio Cassa digitale l'Anticipo non è ammesso, come da modello concordato." },
          { q: "Ho sbagliato un movimento su una cassa già chiusa", a: "Chiedi alla Direzione di 'Riaprire' la cassa: potrai correggere e verrà richiusa." },
          { q: "Vedo solo il mio foglio, è normale?", a: "Sì: i collaboratori vedono solo il proprio FC; la vista completa è riservata alla Direzione." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
